import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationAlertService {
  constructor() {}

  /**
   * Alert generico per mostrare sia l'avvenuta azione
   * sia un errore nell'azione stessa.
   * @param type il tipo di response, success o error
   * @param title il messaggio da visualizzare tra custom ed e.message
   */
  responseToast(type: SweetAlertIcon, title: string) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      icon: type,
      iconColor: type == 'success' ? '#3dc93d' : '#ff4747',
      title: title,
      didOpen: toast => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  }

  /**
   * Alert che gestisce la conferma su specifiche azioni, come ad esempio
   * l'eliminazione di un elemento
   * @param textConfirm testo da visualizzare nel toast alla richiesta di conferma
   * @param apiLogic la logica da attivare alla conferma
   */
  confirmToast(apiLogic: () => void, textConfirm: string) {
    Swal.fire({
      text: textConfirm,
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      focusConfirm: false,
      customClass: {
        popup: 'main-font'
      },
      backdrop: '#f4f3efad',
      position: 'center'
    }).then(result => {
      if (result.isConfirmed) {
        apiLogic();
      }
    });
  }
}
